import { render, staticRenderFns } from "./NewPayments.vue?vue&type=template&id=728db42c&scoped=true"
import script from "./NewPayments.vue?vue&type=script&lang=js"
export * from "./NewPayments.vue?vue&type=script&lang=js"
import style0 from "./NewPayments.vue?vue&type=style&index=0&id=728db42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728db42c",
  null
  
)

export default component.exports